<div class="core-edit-max-width">
  <div class="flex-row-space-between">
    <h1>Firmware erstellen</h1>
  </div>

  <form *ngIf="form" [formGroup]="form">

    <core-input-dropdown
      id="softwareType"
      label="Software Type"
      [options]="softwareTypeOptions"
      formControlName="softwareType"
      [disabled]="!userCanEdit">
    </core-input-dropdown>

    <core-input-dropdown
      id="moduleType"
      label="Module Type"
      [options]="moduleTypeOptions"
      optionValue="code"
      optionLabel="name"
      formControlName="moduleTypeCode"
      [disabled]="!userCanEdit">
    </core-input-dropdown>

    <core-input-dropdown
      id="chipType"
      label="Chip Type"
      [options]="chipTypeOptions"
      optionValue="code"
      optionLabel="name"
      formControlName="chipTypeCode"
      [disabled]="!userCanEdit">
    </core-input-dropdown>

    <core-input-dropdown
      id="displayType"
      label="Display Type"
      [options]="displayTypeOptions"
      optionValue="code"
      optionLabel="name"
      formControlName="displayTypeCode"
      [disabled]="!userCanEdit">
    </core-input-dropdown>

    <core-input-number
      formControlName="version"
      id="version"
      label="Version"
      [min]="0"
      [disabled]="true">
    </core-input-number>

    <div class="col-12 mb-3 mt-3">
      <div class="form-check">
        <input type="checkbox" class="form-check-input" id="isInitializer" formControlName="isInitializer" [disabled]="!userCanEdit">
        <label class="form-check-label" for="isInitializer">Is Initializer Software?</label>
      </div>
    </div>

    <div class="col-12">
      <label for="firmwareFile">Firmware-Datei (.bin)</label>
      <input type="file" id="firmwareFile" accept=".bin" (change)="onFileSelected($event)" [disabled]="!userCanEdit" />
    </div>

    <core-button-submit
      (click)="save()"
      [disabled]="form.invalid || form.disabled"
      id="button_submit">
    </core-button-submit>

  </form>

  <div *ngIf="progress !== null" class="mt-2">Upload: {{progress}}%</div>
  <div *ngIf="error" class="mt-2 alert alert-danger">{{error}}</div>
</div>
